// /**
//  * Zones - Add
//  */

// React
import React, {useState} from 'react';

// react hook form
import {useForm} from 'react-hook-form';

// UI
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';
import {TextField, Grid, Button, Hidden, Checkbox} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiPhoneOutline,
  mdiMapClockOutline,
  mdiVectorPolylineEdit,
} from '@mdi/js';

// helpers
import {flattenObject, removeEmptyValueObject} from '../../../utils/helpers';

// Type
import {addAisle} from '../interfaces';

type Props = {
  createZone: (body: addAisle) => void;
  count: number;
  error: any;
  onClose: () => void;
};

type Inputs = {
  name: string;
  aisleCount: number;
  columnCount: number;
  unitCount: number;
  rowCount: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      // width: '25ch',
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      // marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
  })
);

export default function Add(props: Props) {
  const classes = useStyles();
  const [wastage, setWastage] = useState(false as boolean);
  const {register, handleSubmit, watch, errors} = useForm<Inputs>();
  const onSubmit = ({columnCount, unitCount, rowCount}: Inputs) => {
    props.createZone({
      name: props.count,
      columnCount,
      unitCount,
      rowCount,
      wastage,
    });
  };

  // const handleChange = (event: React.ChangeEvent<{value: unknown}>) => {};

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={4} alignItems="flex-start">
        <Grid container justify="center" item xs={12} alignItems="flex-end">
          <Grid xs={6}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiVectorPolylineEdit}
                  size={1}
                  className={classes.icon}
                />
              </span>

              <div style={{width: '100%'}}>
                <TextField
                  type="text"
                  fullWidth
                  id="name"
                  name="name"
                  label="نام راهرو"
                  value={props.count}
                  disabled
                />
              </div>
            </div>
          </Grid>
        </Grid>

        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiVectorPolylineEdit}
                size={1}
                className={classes.icon}
                style={{transform: 'rotate(-90deg)'}}
              />
            </span>

            <span style={{width: '100%'}}>
              <TextField
                type="number"
                fullWidth
                id="columnCount"
                name="columnCount"
                label="تعداد ستون"
                inputRef={register({
                  required: true,
                  pattern: {
                    value: /[0-9]/,
                    message: 'مقدار وارد شده باید عدد باشد',
                  },
                })}
                error={errors.columnCount && true}
              />
            </span>
          </div>
        </Grid>

        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiVectorPolylineEdit}
                size={1}
                className={classes.icon}
              />
            </span>
            <span style={{width: '100%'}}>
              <TextField
                type="number"
                fullWidth
                id="rowCount"
                name="rowCount"
                label="تعداد طبقات"
                error={errors.rowCount && true}
                inputRef={register({
                  required: true,
                  pattern: {
                    value: /[0-9]/,
                    message: 'مقدار وارد شده باید عدد باشد',
                  },
                })}
              />
            </span>
          </div>
        </Grid>

        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiVectorPolylineEdit}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                type="number"
                fullWidth
                id="unitCount"
                name="unitCount"
                label="تعداد یونیت"
                inputRef={register({
                  required: true,
                  pattern: {
                    value: /[0-9]/,
                    message: 'مقدار وارد شده باید عدد باشد',
                  },
                })}
                error={errors.unitCount && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Checkbox
                checked={wastage}
                onChange={e => setWastage(e.target.checked)}
                color="secondary"
                inputProps={{
                  'aria-label': 'secondary checkbox',
                }}
              />
            </span>

            <div style={{width: '100%', marginTop: '20px'}}>
              <span>ضایعات</span>
            </div>
          </div>
        </Grid>
        <Grid
          container
          justifyContent="flex-end"
          style={{borderTop: '1px solid #000', paddingTop: '10px'}}
        >
          <Grid item container xs={2} style={{margin: '8px'}}>
            <Button
              fullWidth
              variant="outlined"
              onClick={props.onClose}
              size="large"
              data-cy="search"
            >
              {`انصراف`}
            </Button>
          </Grid>
          <Grid item container xs={4} style={{margin: '8px'}}>
            <Button
              fullWidth
              type="submit"
              size="large"
              data-cy="search"
              autoFocus
              variant="contained"
              color="primary"
              disabled={
                Object.keys(flattenObject(removeEmptyValueObject({...watch()})))
                  .length === 0
              }
            >
              {`ایجاد راهرو`}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
